var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonBase } from '@mui/material';
import { KeypadButton as BaseKeypadButton } from 'hx-ui';
import { IoMdBackspace } from 'react-icons/io';
export function KeypadButton(props) {
    if (props.shortcut === 'Backspace') {
        return (_jsx(ButtonBase, __assign({ className: "rounded-full", onClick: props.onClick }, { children: _jsx(IoMdBackspace, {}) })));
    }
    return _jsx(BaseKeypadButton, __assign({}, props));
}
